<template>
  <DsfFormControlBox class="ds-codeeditor" :owner="_self">
    <template v-slot:simple>
      <DsfTextProxy v-model="value" v-bind="_self.$props"></DsfTextProxy>
      <span v-if="value != ''">{{ append }}</span>
      <slot name="error">
        <div v-if="errors.length>0" class="ds-error-text">{{ errorsMsg }}</div>
      </slot>
    </template>
    <template v-slot:content>
      <div v-if="!readOnly" :style="{'height':unitSize(height)}">
        <monaco-editor v-if="!isRefresh" ref="editor" :language="language" :code="value" :options="options" @codeChange="codeChangeHandler" @blur="codeBlurHandler"></monaco-editor>
      </div>
      <div v-else class="ds-form-readonly" :style="{'height':unitSize(height)}">
        <monaco-editor v-if="!isRefresh" ref="editor" :language="language" :code="value" :options="options" @codeChange="codeChangeHandler" @blur="codeBlurHandler"></monaco-editor>
      </div>
      <slot name="error">
        <div v-if="errors.length>0" class="ds-error-text">{{ errorsMsg }}</div>
      </slot>
    </template>
  </DsfFormControlBox>
</template>
<script>
import monacoEditor from "../../../editor/monacoEditor.vue";
export default dsf.component({
  name: "DsfCodeEditor",
  ctrlCaption: "代码编辑器",
  mixins: [$mixins.formControl],
  components: { monacoEditor },
  props: {
    height: {
      type: [String, Number],
      default: 400
    },
    language: {
      type: String,
      default: "javascript"
    },
    metadata: {
      type: Object,
      default() {
        let mdata = dsf.metadata.get("text-meta-data");
        dsf.mix(mdata.valueAttributes[0], { length: 4000 });
        return mdata;
      }
    }
  },
  data() {
    return {
      isRefresh: false,
      value2: "",
      options: {
        readOnly: this.readOnly
      }
    };
  },
  computed: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  methods: {
    resize() {
      this?.$refs?.editor?.layout();
    },
    codeChangeHandler: function (editor) {
      this.value2 = editor.getValue();
      // this.emitValueChange(code);
    },
    codeBlurHandler: function (editor) {
      this.emitValueChange(this.value2);
      this.$nextTick(() => {
        this.emitFormValidate(this.value2);
        this.$dispatch("blur", this.value2);
      });
    }
  },
  beforeDestroy() {},
  destroyed() {},
  watch: {
    language: {
      handler(v, ov) {
        this.isRefresh = true;
        this.$nextTick(() => {
          this.isRefresh = false;
        });
      }
    },
    readOnly: {
      handler(v, ov) {
        this.isRefresh = true;
        this.options.readOnly = v;
        this.$nextTick(() => {
          this.isRefresh = false;
        });
      }
    },
    height: {
      handler(v, ov) {
        this.resize();
      }
    }
  }
});
</script>